import React from 'react';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import './invite_friends.less';
import './account.less';
import {Link} from 'react-router';
import ProfileNavBar from './profile_navbar/profile_navbar';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
const config = require('../../config/config');
const WEBSITE_URL = config.WEBSITE_URL;
import CONSTANTS from '../common_constants';
import ShowError from '../components/error/show_error';

class InviteFriendsDetails extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          error: '',
          inviteUrl: ''
      }
    }

    componentDidMount(){
      const self = this;
      const userId = self.props.userData.userId;

      const inviteParams = {
        tags: [ 'tag1', 'tag2' ],
        channel: 'AWB',
        feature: "AWB Invitation",
        data: {
           Inviter: userId,
          '$deeplink_path': '/signup/' + userId,
          '$always_deeplink': true,
          '$one_time_use': true,
          '$email_subject': 'Welcome to AWB',
          '$og_title': 'AWB',
          '$og_description': 'AWB Invitation',
          '$android_url' : CONSTANTS.ANDROID_URL,
          '$ios_url' :CONSTANTS.IOS_URL
        }
      };

      branch.link(inviteParams, function(err, link) {
        if(link) self.setState({inviteUrl: link});
        if(err) self.setState({error: err});
      });
    }

    render() {

        const {state,props} = this;
        const invite_friends_img_url = "../../public/images/account/invite_friends.png"

        const url ='mailto:?subject='+ "Welcome to AWB" + '&body=Click on link to join AWB%0A%0A'+encodeURIComponent(state.inviteUrl)+'%0D%0A%0D%0A';
        return (
          <div className="invite-friends-details-wrap">
              {state.error && <ShowError errorMessage={state.error}/>}
              <div className="invite-friends-img" style={{"backgroundImage": 'url("' + invite_friends_img_url+ '")'}}></div>
              <div className="heading">
                Invite friends and save!
              </div>
              <div className="content">
                Invite a friend and get 20% off your next shipment.
              </div>
              <div className="invite-link">
                  {state.inviteUrl}
              </div>
              <button className="btn orange"><a href={url}>Invite Friends</a></button>
          </div>
        )
    }
}

class InviteFriends extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
        this.props.authActions.logout().always(() => {
            cookies.delete('_sd');
            document.location.href = '/';
        });
    }

    render() {
        const {props, state} = this;
        const {userData} = props.authState;
        let user = {
            name: '',
            imageUrl: '',
            isVerified: '',
            creditAmount: ''
        };

        if (props.authState) {
            user.name = userData.name;
            user.imageUrl = userData.profileImageUrl;
            user.isVerified = userData.isVerified;
            user.creditAmount = userData.creditAmount
        }

        return (
            <div className="account-details-wrap">
              <DashBoardHeader user={user} logout={this.logout}/>
              <div className="account-header-wrap">
                <div className="wrapper">
                    <h2 className="page-header account-page-header">Account</h2>
                </div>
              </div>
              <div className="wrapper account-wrapper">
                <div className="profile-nav-bar-component">
                    <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                </div>
                <div className="account-details-component">
                    <InviteFriendsDetails userData={props.authState.userData}/>
                </div>
              </div>
              <LoggedinFooter/>
            </div>
        )
    }
}

InviteFriends = connect((state) => {
    return {authState: state.app.auth}
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch)
    }
})(InviteFriends);

export default InviteFriends;



// WEBPACK FOOTER //
// app/profile/inivite_friends.jsx